import AxiosClient from "../../../services/axios.services";

class ObjectiveCompetencyServices {
  getObjectiveCompetency = (params) =>
    AxiosClient.get("/api/app/evaluacion_objetivos_competencias/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getObjectiveCompetencyById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_objetivos_competencias/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveObjectiveCompetency = (data) =>
    AxiosClient.post("/api/app/evaluacion_objetivos_competencias/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editObjectiveCompetency = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_objetivos_competencias/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteObjectiveCompetency = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_objetivos_competencias/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new ObjectiveCompetencyServices();
